export const SCROLL_OFFSET = 20;
export const BOTTOM_PADDING_PER_ITEM = 75;
export const CHILD_ITEM_OFFSET = 10;

// Scroll detection constants
export const SCROLL_IDLE_THRESHOLD_MS = 150; // Time without scroll to consider "stopped"
export const SCROLL_POSITION_TOLERANCE = 2; // Pixels tolerance for "reached target"
export const MANUAL_SCROLL_THRESHOLD = 10; // Min pixels to detect manual scroll
export const INIT_SCROLL_DELAY_MS = 300; // Delay after initialization scroll completes
